import React from "react";

export default () => (
    <section id="careerpaths">
        <div className="section_title">
            <p>CAREER PATHS</p>
            <h2>ソルパックの人材育成</h2>
            <div className="title_label" />
        </div>
        <div className="section_contents">
            <div className="careerpaths_txt">
                <p>IT技術者にとって必要な情報技術および知識が一定以上の水準であることを証明するため、情報処理関連の資格取得を推進しています。<br />自己のスキルを認識し、明確なキャリアパスを設定することにより、より高いレベルのプロフェッショナルを目指すことが可能です。</p>
            </div>
            <div className="img">
                <img className="image" src="images/careerpaths/careerpaths.jpg" alt="" />
            </div>
        </div>
    </section>
)


// WEBPACK FOOTER //
// ./src/Home/CareerPaths.js